import React, { useEffect, useState, useMemo } from 'react';
import { cloneObject } from '../../utils';

import Button from '../Button';
import Input from '../Inputs/Input';
import Select from '../Inputs/Select';
import DatepickerRange from '../Inputs/DatepickerRange'

import * as S from './styles';

function SearchInput({ type, ...rest }) {
    switch (type) {
        case 'select':
            return <Select {...rest} />;
        case 'dateRange':
            return <DatepickerRange {...rest} />;
        default:
            return <Input {...rest} />;
    }
}

function SearchContainer({ field, type, buttonLabel, onSearch, disabled, ...rest }) {
    const [input, setInput] = useState({ ...cloneObject(field) });
    const isRequiredFieldFilled = useMemo(() => input.required && input.value);

    useEffect(() => {
        setInput({ ...cloneObject(field) });
    }, [field]);

    function handleKeyPress(event) {
        // caso pressionado enter e o pesquisar nao estiver desabilitado, entao chama a funcao de busca
        if (event.charCode === 13 && !disabled) {
            onSearch(input.unmaskedValue || input.value);
        }
    }

    function handleInputBlur() {
        if (!isRequiredFieldFilled) {
            setInput({...input, error: input.requiredMessage || 'Preencha com um valor válido.'})
            input.error = input.requiredMessage || 'Preencha com um valor válido.';
        }
    }

    return (
        <S.SearchContainer className="search-container">
            <SearchInput
                field={input}
                type={type}
                onKeyPress={handleKeyPress}
                onChange={(event) => setInput({ ...field, ...event })}
                onBlur={handleInputBlur}
                {...rest}
            />

            <Button type="primary" disabled={disabled || !isRequiredFieldFilled} onClick={() => onSearch(input.unmaskedValue || input.value)}>
                {buttonLabel || 'Pesquisar'}
            </Button>
        </S.SearchContainer>
    );
}

export default SearchContainer;
